module.exports = __webpack_public_path__ + "media/images/icons/flags/BF-a24c21e661a540f8ea6dbf925b5478cc.svg";